import Vue from 'vue';
import Router from 'vue-router';
import VeeValidate from 'vee-validate';
import VueScrollactive from 'vue-scrollactive/src/scrollactive.vue';
import VueScrollTo from 'vue-scrollto';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import Loading from 'vue-loading-overlay';
import routes from './routes';

import App from './App.vue';
import './scss/styles.scss';
import 'vue-loading-overlay/dist/vue-loading.css';

Vue.use(Router);
Vue.use(VeeValidate, {});

Vue.component('scrollactive', {
    extends: VueScrollactive,
    props: {
        modifyUrl: {
            type: Boolean,
            default: false,
        },
        highlightFirstItem: {
            type: Boolean,
            default: true,
        },
    },
});
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('loading', {
    extends: Loading,
    props: {
        loader: {
            type: String,
            default: 'dots',
        },
        width: {
            type: Number,
            default: 128,
        },
        height: {
            type: Number,
            default: 32,
        },
        color: {
            type: String,
            default: '#eb9350',
        },
        opacity: {
            type: Number,
            default: 0.6,
        },
        canCancel: {
            type: Boolean,
            default: false,
        },
        isFullPage: {
            type: Boolean,
            default: true,
        },
    },
});

// eslint-disable-next-line no-multi-assign
window.jQuery = window.$ = require('jquery');
require('bootstrap');

Vue.config.productionTip = false;

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

new Vue({
    router,

    data: {
        currentSection: '#home',
        navbar: [
            { href: '#home', text: 'Home' },
            { href: '#unique-approach', text: 'Unique Approach' },
            { href: '#testimonials', text: 'Testimonials' },
            { href: '#our-difference', text: 'Our Difference' },
            { href: '#the-team', text: 'The Team' },
            { href: '#contact-us', text: 'Contact Us' },
        ],
        clickToScroll: true,
        head: {
            title: '',
        },
    },

    head: {
        title() {
            return {
                inner: this.head.title,
                separator: ' ',
            };
        },

        meta() {
            const meta = [
                {
                    name: 'description',
                    c: this.head.meta.description,
                },
            ];

            if (process.env.NODE_ENV === 'production') {
                if (process.env.VUE_APP_GOOGLE_SITE_VERIFICATION) {
                    meta.push({
                        name: 'google-site-verification',
                        c: process.env.VUE_APP_GOOGLE_SITE_VERIFICATION,
                    });
                }
            } else {
                meta.push({
                    name: 'robots',
                    c: 'none',
                });
            }

            return meta;
        },
    },

    watch: {
        'head.title': function (value) {
            document.title = value;
        },

        'head.description': function (value) {
            document.description = value;
        },

        $route(to) {
            if (to.hash.length) {
                return;
            }

            this.clickToScroll = (to.name !== 'lizmann' && to.name !== 'romanmeytin');

            if (!this.clickToScroll) {
                VueScrollTo.scrollTo(document.querySelector('body'), 500);
            }

            this.head.title = to.meta.title || 'EmpowerDirect.com';
        },
    },

    methods: {
        getSectionClass(section) {
            return this.currentSection === section ? 'is-active' : '';
        },
    },

    render: (h) => h(App),
}).$mount('#app');
